import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgRedux } from '@angular-redux/store';
import { ArgosState } from '../../../core/argos-state';
import { Mask } from '../../pipe/interface/mask';
import { OnChanges } from '@angular/core/src/metadata/lifecycle_hooks';
import { ToastService } from '../../service/toast.service';
import { MaterializeAction } from 'angular2-materialize';
import * as datePickerOptions from '../../../core/date-picker-options';

declare var Materialize: any;

@Component({
  selector: 'tx-filter',
  templateUrl: './tx-filter.component.html',
  styleUrls: ['./tx-filter.component.css']
})
export class TxFilterComponent implements OnInit, OnChanges {
  @Input() filterField: Array<string>;
  @Input() actionType: string;
  @Input() inputType = 'text';
  @Input() mask: Mask;
  @Input() maxChar: number;
  @Input() filterOptions: any;
  @Input() label: string;
  @Output() txOnFilterApply: EventEmitter<any>;
  filter: any;
  typedValue: any;
  dateActions = new EventEmitter<string|MaterializeAction>();
  datePickerFormat = datePickerOptions.minDatePicker;

  constructor(private _ngRedux: NgRedux<ArgosState>,
              private _toastService: ToastService) {
    this.txOnFilterApply = new EventEmitter();
  }

  ngOnInit() {
  }

  ngOnChanges() {
    this.updateCurrentFilterValue();
  }

  updateCurrentFilterValue() {
    this._ngRedux.select(this.filterField)
      .subscribe(value => this.typedValue = value);
  }

  toggleDatePicker() {
    this.dateActions.emit({action: 'pickadate', params: ['open']});
  }

  applyFilter() {
    if (this.inputType !== 'toggle') {
      this.applyTypedValue();
    } else {
      this.applyToggleValue();
    }
  }

  cleanFilter() {
    this._ngRedux.select([this.filterField[0]])
      .subscribe(filter => {
        this.filter = filter;
        this.typedValue = undefined;
        this.updateFieldValue();
      });
  }

  applyMask(event) {
    if (this.mask) {
      this.typedValue = this.mask.transform(event.target.value, event.key);
    } else {
      this.typedValue = event.target.value;
    }
  }

  getObjectKeys(object) {
    if (object) {
      return Object.keys(object);
    }
    return [];
  }

  private applyTypedValue() {
    if (this.typedValue) {
      this._ngRedux.select([this.filterField[0]])
        .subscribe(filter => {
          this.filter = filter;
          this.updateFieldValue();
        });
    } else {
      this.showMessage('Informe um valor para o filtro!');
    }
  }

  private applyToggleValue() {
    if (!this.typedValue) {
      this.typedValue = false;
    }
    this._ngRedux.select([this.filterField[0]])
    .subscribe(filter => {
      this.filter = filter;
      this.updateFieldValue();
    });
  }

  private updateFieldValue() {
    const fields = this.getFilterFields();
    let target = this.filter;
    let index = 0;
    // accessing correct field to update
    for (; index < fields.length - 1; index++) {
      target = target[fields[index]];
    }
    target[fields[index]] = this.typedValue;
    this.dispatchEvents();
  }

  private dispatchEvents() {
    this._ngRedux.dispatch({ type: this.actionType, body: { filter: this.filter } });
    this.txOnFilterApply.emit();
  }

  private getFilterFields() {
    return this.filterField.slice(1, this.filterField.length);
  }

  private showMessage(message: string) {
    this._toastService.showMessage(message, 4000);
  }

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/component/tx-filter/tx-filter.component.ts